import { gql } from "@apollo/client";

export const SELECT_CONTENT_NODE = gql`
    mutation SelectContentNode($chatId: ID!, $contentNodeId: ID!, $select: Boolean!) {
        selectContentNode(chatId: $chatId, contentNodeId: $contentNodeId, select: $select) {
            id
            type
            sizeInTokens
            isPromptable
            isViewable
            metadata
            childNodes {
                id
                type
                sizeInTokens
                isPromptable
                isViewable
                metadata
            }
        }
    }
`;